import {
    CardItem,
    CardClickedEvent,
    CardClickedEventProps,
    ClickableCardItems,
    CardEvents,
} from '../client-data-types/card-types'
import { ComponentEvent } from './component-event'
import { PlayerEvent } from './video-event-types'
import { DataLayerEventName } from 'common/helpers/DataLayerEventName'

export function createCollectionAvailableEvent(
    cards: (CardItem | string)[],
    collectionName: string,
    payloadOverrides: Omit<CollectionAvailableEventProps, 'collectionCardCount'> = {}
): CollectionEvent {
    const payload: CollectionAvailableEventProps = {
        collectionCardCount: cards.length,
        ...payloadOverrides,
    }
    for (let cardIndex = 0; cardIndex < cards.length; cardIndex++) {
        const card = cards[cardIndex]
        const cardKey = `card${cardIndex + 1}Info`
        payload[cardKey] = getCardInfo(card)
    }

    return {
        type: DataLayerEventName.collectionAvailable,
        originator: collectionName,
        payload,
    }
}

export function createCardClickedEvent(
    item: ClickableCardItems,
    originator: string,
    cardFormat: CardClickedEventProps['cardFormat'],
    cardNumber: number,
    componentType?: string
): CardClickedEvent {
    return {
        type: DataLayerEventName.cardClicked,
        originator,
        componentType,
        payload: {
            cardItem: item,
            cardFormat,
            cardNumber: cardNumber,
            cardInfo: getCardInfo(item),
        },
    }
}
export function getCardInfo(card: ClickableCardItems) {
    if (typeof card === 'string') {
        return card
    }

    switch (card.cardType) {
        case 'publication':
            return `Publication: ${card.shortHeadline}`
        case 'marketing-redirect-tile':
            return `Marketing tile: ${card.url}`
        case 'breaking-news':
            return `BreakingNews: ${card.shortHeadline}`
        default:
            return `Unknown card type`
    }
}

export interface CollectionAvailableEventProps {
    collectionCardCount: number
    [cardDescriptions: string]: string | number
}
export interface CollectionAvailableEvent extends ComponentEvent<CollectionAvailableEventProps> {
    type: DataLayerEventName.collectionAvailable
}

export type CollectionEvent = PlayerEvent | CardEvents | CollectionAvailableEvent
